import {
    IDB_rowRead,
    IDB_rowsDelete,
    IDB_rowsReadAll,
    IDB_rowsReadSome,
    IDB_rowsWrite,
    IDB_rowWrite,
} from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { AppUnitType } from '../../../shared/domain/units/types.no-deps'

export function IDB_unitTypeRead(id: number) {
    return IDB_rowRead<AppUnitType>(IDB_globalDb, 'unit_types', id)
}

export function IDB_unitTypesDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'unit_types', ids)
}

export function IDB_unitTypesReadSome(ids: number[]) {
    return IDB_rowsReadSome<AppUnitType>(IDB_globalDb, 'unit_types', ids)
}

export function IDB_unitTypesReadAll() {
    return IDB_rowsReadAll<AppUnitType>(IDB_globalDb, 'unit_types')
}

export function IDB_unitTypesWrite(unitTypes: AppUnitType[]) {
    return IDB_rowsWrite(IDB_globalDb, 'unit_types', unitTypes)
}

export function IDB_unitTypeWrite(unitType: AppUnitType) {
    return IDB_rowWrite(IDB_globalDb, 'unit_types', unitType)
}
